export default [
  {
    path: '/forget',
    name: 'forget',
    component: () => import('@/views/user/forget/forget.vue'),
    meta: { title: 'app_account_safe', ignoreAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/user/login/login.vue'),
    meta: { title: 'app_login_account', ignoreAuth: true }
  },
  {
    path: '/enterpriseLogin',
    name: 'enterpriseLogin',
    component: () => import('@/views/user/login/enterpriseLogin.vue'),
    meta: { title: 'app_login_account', ignoreAuth: true }
  },
  {
    path: '/phoneLogin',
    name: 'phoneLogin',
    component: () => import('@/views/user/login/phoneLogin.vue'),
    meta: { title: 'app_login_phone', ignoreAuth: true }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/user/register/register.vue'),
    meta: { title: 'app_account_safe', ignoreAuth: true }
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import('@/views/user/reset/reset.vue'),
    meta: { title: 'app_account_safe', ignoreAuth: true }
  },
  {
    path: '/setNewPassword',
    name: 'setNewPassword',
    component: () => import('@/views/user/setNewPassword/setNewPassword.vue'),
    meta: { title: 'app_account_safe', ignoreAuth: true }
  },
  {
    path: '/multiAccount',
    name: 'MultiAccount',
    component: () => import('@/views/user/multiAccount/index.vue'),
    meta: { title: 'app_account_safe', ignoreAuth: true }
  },
  {
    path: '/shareError',
    name: 'ShareError',
    component: () => import('@/components/ShareError.vue'),
    meta: { title: '' }
  },
  {
    path: '/userAgreement',
    name: 'UserAgreement',
    component: () => import('@/views/user/agreement/userAgreement.vue'),
    meta: { title: 'login_user_agreement', ignoreAuth: true }
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/user/agreement/privacyPolicy.vue'),
    meta: { title: 'app_privacy_policy', ignoreAuth: true }
  },
  {
    path: '/collectedInformation',
    name: 'CollectedInformation',
    component: () => import('@/views/user/agreement/collectedInformation.vue'),
    meta: { title: 'personal_Information_list', ignoreAuth: true }
  },
  {
    path: '/cookieSettings',
    name: 'CookieSettings',
    component: () => import('@/views/user/login/CookieSettings.vue'),
    meta: { title: 'Cookie 设置', ignoreAuth: true }
  }
]
